// Adds the desktop close button, outside .search-modal__content, to the header search Tab cycle.
(function () {
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    ).filter((element) => element.getClientRects().length > 0);
  }

  document.querySelectorAll('details-modal.header__search').forEach((headerSearch) => {
    const closeButton = headerSearch.querySelector(':scope > .search-modal__close-button');
    const content = headerSearch.querySelector('.search-modal__content');

    if (!closeButton || !content) return;

    // Below small-hide the desktop close button is hidden; leave mobile to the shared trap.
    function desktopCloseButtonVisible() {
      return closeButton.getClientRects().length > 0;
    }

    // Capture phase so this runs before global.js trapFocus and the two traps do not fight.
    headerSearch.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Tab') return;
        if (!desktopCloseButtonVisible()) return;

        const elements = getFocusableElements(content);
        if (!elements.length) return;
        const first = elements[0];
        const last = elements[elements.length - 1];

        if (event.target === closeButton) {
          event.preventDefault();
          event.stopPropagation();
          (event.shiftKey ? last : first).focus();
          return;
        }

        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          event.stopPropagation();
          closeButton.focus();
          return;
        }

        if (event.target === first && event.shiftKey) {
          event.preventDefault();
          event.stopPropagation();
          closeButton.focus();
        }
      },
      true
    );
  });
})();
